import {createSelector, createSlice} from "@reduxjs/toolkit";
import {selectUserSettings} from "./userSettingsSlice";


const initialState = {
    wallets: [],
    groups: null,
    transactionWallets: []
}

const walletSlice = createSlice({
    name: 'wallet',
    initialState: initialState,
    reducers: {
        loadWalletsSuccess(state, action) {
            return {...state, wallets: action.payload.wallets, groups: action.payload.groups}
        },
        updateWalletSuccess(state, action) {
            const savedWallet = action.payload;
            let isWalletChanged = false;
            const newState = state;

            if(savedWallet.walletGroup) {
                const groups = state.groups || [];
                const existGroup = groups.find(group => group.id === savedWallet.walletGroup);
                if(existGroup) {
                    const balances = existGroup.balances || [];
                    balances.forEach((wallet, index) => {
                        if (wallet.id === savedWallet.id) {
                            balances[index] = savedWallet;
                            isWalletChanged = true;
                        }
                    });
                    if (!isWalletChanged) {
                        balances.push(savedWallet);
                    }
                    existGroup.balances = balances;
                }
                if(state.wallets.find(wallet => wallet.id === savedWallet.id)) {
                    state.wallets = state.wallets.filter(wallet => wallet.id !== savedWallet.id)
                }
            } else {
                const wallets = state.wallets;


                // if(savedWallet.group) {
                //     wallets.forEach((wallet, index) => {
                //         if (wallet.id === savedWallet.id) {
                //             wallets[index] = savedWallet;
                //             isWalletChanged = true;
                //         }
                //     });
                // }
                wallets.forEach((wallet, index) => {
                    if (wallet.id === savedWallet.id) {
                        wallets[index] = savedWallet;
                        isWalletChanged = true;
                    }
                });
                if (!isWalletChanged) {
                    wallets.push(savedWallet);
                }

                (state.groups || []).forEach(group => {
                    const existWallet = (group.balances || []).find(wallet => wallet.id === savedWallet.id)
                    if(existWallet) {
                        group.balances = group.balances.filter(wallet => wallet.id !== savedWallet.id)
                    }
                })
            }

            if (state.transactionWallets?.length) {
                state.transactionWallets = state.transactionWallets.map((wallet) =>
                    wallet.id === savedWallet.id ? {...wallet, ...savedWallet} : wallet
                );
            }

            return newState;
        },
        deleteWalletSuccess(state, action) {
            const id = action.payload;
            const wallets = state.wallets.filter(wallet => wallet.id != id);
            const transactionWallets = (state.transactionWallets || []).filter(wallet => wallet.id != id);
            return {...state, wallets: wallets, transactionWallets}
        },
        updateGroupSuccess(state, action) {
            const savedGroup = action.payload;
            const groups = [...state.groups];
            let isGroupChanged = false;

            groups.forEach((group, index) => {
                if (group.id === savedGroup.id) {
                    savedGroup.balances = groups[index].balances;
                    groups[index] = savedGroup;
                    isGroupChanged = true;
                }
            });
            if (!isGroupChanged) {
                groups.push(savedGroup);
            }
            return {...state, groups: groups}
        },
        deleteGroupSuccess(state, action) {
            const id = action.payload;
            const groups = state.groups.filter(group => group.id != id);
            return {...state, groups: groups}
        },
        mergeWalletsFromTransactions(state, action) {
            const walletsFromApi = action.payload || [];
            if (walletsFromApi.length === 0) return state;
            const transactionWallets = [...(state.transactionWallets || [])];
            const byId = new Map(transactionWallets.map((w) => [w.id, w]));
            walletsFromApi.forEach((w) => byId.set(w.id, w));
            return { ...state, transactionWallets: Array.from(byId.values()) };
        }
    }
})

export const {loadWalletsSuccess, updateWalletSuccess, updateGroupSuccess, deleteWalletSuccess, deleteGroupSuccess, mergeWalletsFromTransactions} = walletSlice.actions
export default walletSlice.reducer


export const fetchWalletsAndGroups = () => async (dispatch, getState) => {
    fetch('/api/wallets')
        .then((response) => {
            if (response.ok) {
                response.json().then(json =>
                    dispatch(loadWalletsSuccess(json)));
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export const saveWallet = (wallet, onSuccess) => async (dispatch, getState) => {
    fetch('/api/wallets', {
        method: "PUT",
        body: JSON.stringify(wallet),
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((response) => {
            if (response.ok) {
                response.json().then(json => {
                    dispatch(updateWalletSuccess(json));
                    if(onSuccess) {
                        onSuccess();
                    }
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export const deleteWallet = (wallet, onSuccess) => async (dispatch, getState) => {
    fetch('/api/wallets?id=' + wallet.id, {
        method: "DELETE",
        // body: JSON.stringify(wallet),
    })
        .then((response) => {
            if (response.ok) {
                response.json().then(json => {
                    dispatch(deleteWalletSuccess(wallet.id));
                    if(onSuccess) {
                        onSuccess();
                    }
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export const saveGroup = (group, onSuccess) => async (dispatch, getState) => {
    fetch('/api/wallet-groups', {
        method: "PUT",
        body: JSON.stringify(group),
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((response) => {
            if (response.ok) {
                response.json().then(json => {
                    dispatch(updateGroupSuccess(json));
                    if(onSuccess) {
                        onSuccess();
                    }
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export const deleteGroup = (group, onSuccess) => async (dispatch, getState) => {
    fetch('/api/wallet-groups?id=' + group.id, {
        method: "DELETE",
        // body: JSON.stringify(wallet),
    })
        .then((response) => {
            if (response.ok) {
                response.json().then(json => {
                    dispatch(deleteGroupSuccess(group.id));
                    if(onSuccess) {
                        onSuccess();
                    }
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export const selectAllWallets = (state) => {
    return state.walletSlice.wallets
}

const isNotDeleted = (entity) => entity?.state !== "DELETED";
const isNotInactive = (entity) => entity?.active !== false && entity?.active !== "false";

const selectTransactionWallets = (state) =>
    state.walletSlice.transactionWallets || [];

const selectAllGroupedWallets = (state) => {
    const groups = state.walletSlice.groups || [];
    return groups.flatMap((group) => group.balances || []);
};

const selectAllWalletCandidates = createSelector(
    [selectAllWallets, selectAllGroupedWallets, selectTransactionWallets],
    (wallets, groupedWallets, transactionWallets) => {
        const byId = new Map();
        [...wallets, ...groupedWallets, ...transactionWallets].forEach((wallet) => {
            if (wallet?.id != null) {
                byId.set(wallet.id, wallet);
            }
        });
        return Array.from(byId.values());
    }
);

export const selectActiveWalletsOrSelected = createSelector(
    [selectAllWalletCandidates, (state, selectedWalletId) => selectedWalletId], (wallets, selectedWalletId) => {
    return wallets
        ? wallets.filter(eachWallet => (isNotDeleted(eachWallet) && isNotInactive(eachWallet)) || eachWallet.id == selectedWalletId)
        : []
})

export const selectGroups = (state) =>
    state.walletSlice.groups;

export const selectActiveGroups = createSelector(
    [selectGroups],
    (groups) => (groups || [])
        .filter((group) => isNotDeleted(group) && isNotInactive(group))
        .map((group) => ({
            ...group,
            balances: (group.balances || []).filter((wallet) => isNotDeleted(wallet) && isNotInactive(wallet))
        }))
);

export const selectActiveRootWallets = createSelector(
    [selectAllWallets],
    (wallets) => (wallets || []).filter((wallet) => isNotDeleted(wallet) && isNotInactive(wallet) && !wallet?.walletGroup)
);

// Active non-DEBT wallets, optionally filtered by the user's "main screen" selection.
// Empty selection (NULL/empty CSV in user_settings) means "show all".
export const selectMainScreenWallets = createSelector(
    [selectAllWalletCandidates, selectUserSettings],
    (wallets, settings) => {
        const selectedIds = settings?.mainScreenWalletIds || [];
        const idSet = new Set(selectedIds.map((id) => Number(id)));
        return (wallets || [])
            .filter((wallet) => isNotDeleted(wallet) && isNotInactive(wallet))
            .filter((wallet) => wallet?.walletType !== "DEBT")
            .filter((wallet) => idSet.size === 0 || idSet.has(Number(wallet.id)));
    }
);

// Same as selectMainScreenWallets but ignores the user setting filter; used by
// the settings UI to render the full list of pickable wallets.
export const selectActiveNonDebtWallets = createSelector(
    [selectAllWalletCandidates],
    (wallets) => (wallets || [])
        .filter((wallet) => isNotDeleted(wallet) && isNotInactive(wallet))
        .filter((wallet) => wallet?.walletType !== "DEBT")
);

export const selectWalletById = (state, walletId) => {
    if (walletId == null) return null;
    const wallets = state.walletSlice.wallets || [];
    const found = wallets.find((w) => w.id === walletId || w.id == walletId);
    if (found) return found;
    const groups = state.walletSlice.groups || [];
    for (const group of groups) {
        const balances = group.balances || [];
        const inGroup = balances.find((w) => w.id === walletId || w.id == walletId);
        if (inGroup) return inGroup;
    }
    const transactionWallets = state.walletSlice.transactionWallets || [];
    const fromTransactions = transactionWallets.find((w) => w.id === walletId || w.id == walletId);
    if (fromTransactions) return fromTransactions;
    return null;
};
